import React, { Fragment, useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../components/layouts/MainLayout";
import BookingListTable from "../components/views/bookings/BookingListTable";
import BookingListCard from "../components/views/bookings/BookingListCard";
import Spin from "../components/Spin";
import { bookingListAction } from "../stores/actions";
import * as api from "../api";
import useDebounce from "../lib/useDebounce";

const BookingListContainer = ({ history }) => {
  const hotelId = localStorage.getItem("hotel_id");
  const [isLoading, setIsLoading] = useState(false);
  const [isDebounce, setIsDebounce] = useState(false); //디바운싱 사용 구분을 위해 추가
  const [buildingListItems, setBuildingListItems] = useState([]);
  const [floorListItems, setFloorListItems] = useState([]);
  const {
    bookingListTotal,
    bookingListItems,
    viewType,
    currentPageNumber,
    paginationItem,
    sortItem,
    filterItem,
  } = useSelector((state) => state.bookingList);
  const dispatch = useDispatch();

  const changeViewType = useCallback(
    (viewType) => {
      dispatch(bookingListAction.setViewType(viewType));
    },
    [dispatch]
  );

  const setBookingList = useCallback(
    (bookingList) => {
      dispatch(bookingListAction.setBookingList(bookingList));
    },
    [dispatch]
  );

  const setCurrentPageNumber = useCallback(
    (currentPageNumber) => {
      dispatch(bookingListAction.setCurrentPageNumber(currentPageNumber));
    },
    [dispatch]
  );

  const setPaginationItem = useCallback(
    (paginationItem) => {
      dispatch(bookingListAction.setPaginationItem(paginationItem));
    },
    [dispatch]
  );

  const setSortItem = useCallback(
    (sortItem) => {
      dispatch(bookingListAction.setSortItem(sortItem));
    },
    [dispatch]
  );

  const setFilterItem = useCallback(
    (filterItem, isdebounce) => {
      setIsDebounce(isdebounce); //디바운싱 처리를 위해 하위 Component에서 구분을 받아옴
      dispatch(bookingListAction.setFilterItem(filterItem));
    },
    [dispatch]
  );

  const changeHotel = useCallback(() => {
    dispatch(bookingListAction.initBookingListState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listBuilding = useCallback(async () => {
    try {
      const res = await api.listBuilding({});
      setBuildingListItems(res.data.items);
    } catch (error) {
      throw error;
    } finally {
    }
  }, []);

  const listFloor = useCallback(async (buildingId) => {
    try {
      setIsLoading(true);
      const res = await api.listFloor({ buildingId });
      setFloorListItems(res.data);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const listBooking = useCallback(async () => {
    try {
      // const res = api.listBookingDummy();
      setIsLoading(true);
      const res = await api.listBooking({
        ...filterItem,
        startAt: filterItem.startAt,
        ...sortItem,
        ...paginationItem,
      });
      setBookingList(res.data);
    } catch (error) {
      setBookingList({
        total: 0,
        items: [],
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [setBookingList, filterItem, sortItem, paginationItem]);

  //디바운싱 훅으로 이동
  const handleDebounce = useCallback(
    useDebounce((listBooking) => listBooking(), 300), //0.3초 동안 미입력 시 함수 실행
    []
  );

  useEffect(() => {
    try {
      listBuilding();
      !isDebounce ? listBooking() : handleDebounce(listBooking); //디바운싱 처리
    } catch (error) {
      throw error;
    }
  }, [listBuilding, listBooking, hotelId, isDebounce, handleDebounce]);

  return (
    <Fragment>
      <Spin isSpin={isLoading} />
      <MainLayout
        history={history}
        refresh={() => changeHotel()}
        ContentBody={
          <Fragment>
            {
              {
                table: (
                  <BookingListTable
                    bookingListTotal={bookingListTotal}
                    bookingListItems={bookingListItems}
                    buildingListItems={buildingListItems}
                    floorListItems={floorListItems}
                    filterItem={filterItem}
                    sortItem={sortItem}
                    paginationItem={paginationItem}
                    currentPageNumber={currentPageNumber}
                    viewType={viewType}
                    listFloorApi={listFloor}
                    listBookingApi={listBooking}
                    setFilterItem={setFilterItem}
                    setSortItem={setSortItem}
                    setPaginationItem={setPaginationItem}
                    setCurrentPageNumber={setCurrentPageNumber}
                    changeViewType={changeViewType}
                    history={history}
                  />
                ),
                card: (
                  <BookingListCard
                    bookingListTotal={bookingListTotal}
                    bookingListItems={bookingListItems}
                    buildingListItems={buildingListItems}
                    floorListItems={floorListItems}
                    filterItem={filterItem}
                    paginationItem={paginationItem}
                    // currentPageNumber={currentPageNumber}
                    viewType={viewType}
                    listFloorApi={listFloor}
                    listBookingApi={listBooking}
                    setFilterItem={setFilterItem}
                    setPaginationItem={setPaginationItem}
                    // setCurrentPageNumber={setCurrentPageNumber}
                    changeViewType={changeViewType}
                    history={history}
                  />
                ),
              }[viewType]
            }
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default BookingListContainer;
